'use client';
import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface NotificationPreferences {
	enabled: boolean;
}

const STORAGE_KEY = 'practium_notification_preferences';

const NotificationContext = createContext({
	notificationsEnabled: true,
	toggleNotifications: () => {},
});

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
	const [notificationsEnabled, setNotificationsEnabled] = useState<boolean>(true);
	const [isInitialized, setIsInitialized] = useState(false);

	useEffect(() => {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored) {
			try {
				const parsed: NotificationPreferences = JSON.parse(stored);
				setNotificationsEnabled(parsed.enabled);
			} catch (e) {
				console.error('Erro ao carregar notificações', e);
			}
		}
		setIsInitialized(true);
	}, []);

	useEffect(() => {
		if (isInitialized) {
			const preferences: NotificationPreferences = { enabled: notificationsEnabled };
			localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
		}
	}, [notificationsEnabled, isInitialized]);

	const toggleNotifications = () => setNotificationsEnabled((prev) => !prev);

	return (
		<NotificationContext.Provider value={{ notificationsEnabled, toggleNotifications }}>
			{children}
		</NotificationContext.Provider>
	);
};

export const useNotificationPreferences = () => useContext(NotificationContext);
